import { WIDGET_DEFAULT_FONT } from 'constants/fonts';

import { TEXT_TAG_TO_STYLES_MAP } from '../common/TextBasedWidgets.config';

const DEFAULT_TEXT = 'Click to edit text';

const DEFAULT_PM_NODE_ATTRS = { lineHeight: '1.2', textAlign: 'left' };

// Default text widget data for each widget in the side menu
const DEFAULT_TEXT_WIDGET_DATA = {
  'heading 1': {
    dimension: {
      width: 380,
      height: 43.5,
    },
    proseMirrorData: {
      type: 'heading',
      attrs: {
        ...DEFAULT_PM_NODE_ATTRS,
      },
    },
    style: TEXT_TAG_TO_STYLES_MAP['heading 1'],
  },
  'heading 2': {
    dimension: {
      width: 315,
      height: 36,
    },
    proseMirrorData: {
      type: 'heading',
      attrs: {
        ...DEFAULT_PM_NODE_ATTRS,
      },
    },
    style: TEXT_TAG_TO_STYLES_MAP['heading 2'],
  },
  'heading 3': {
    dimension: {
      width: 250,
      height: 29.5,
    },
    proseMirrorData: {
      type: 'heading',
      attrs: {
        ...DEFAULT_PM_NODE_ATTRS,
      },
    },
    style: TEXT_TAG_TO_STYLES_MAP['heading 3'],
  },
  'heading 4': {
    dimension: {
      width: 215,
      height: 24.5,
    },
    proseMirrorData: {
      type: 'heading',
      attrs: {
        ...DEFAULT_PM_NODE_ATTRS,
      },
    },
    style: TEXT_TAG_TO_STYLES_MAP['heading 4'],
  },
  'heading 5': {
    dimension: {
      width: 195,
      height: 22,
    },
    proseMirrorData: {
      type: 'heading',
      attrs: {
        ...DEFAULT_PM_NODE_ATTRS,
      },
    },
    style: TEXT_TAG_TO_STYLES_MAP['heading 5'],
  },
  'heading 6': {
    dimension: {
      width: 170,
      height: 19.5,
    },
    proseMirrorData: {
      type: 'heading',
      attrs: {
        ...DEFAULT_PM_NODE_ATTRS,
      },
    },
    style: TEXT_TAG_TO_STYLES_MAP['heading 6'],
  },
  paragraph: {
    dimension: {
      width: 164,
      height: 19.5,
    },
    proseMirrorData: {
      type: 'paragraph',
      attrs: DEFAULT_PM_NODE_ATTRS,
    },
    style: TEXT_TAG_TO_STYLES_MAP.paragraph,
  },
};

const DEFAULT_EFFECT = {
  type: '',
  blur: 0,
  transparency: 0,
  offset: 0,
  intensity: 0,
  thickness: 0,
  direction: 0,
  primaryColor: '#000000',
};

const DEFAULT_LETTERSPACING = 0;
const DEFAULT_FONT = WIDGET_DEFAULT_FONT;
const DEFAULT_LINEHEIGHT = '1.2';

export {
  DEFAULT_TEXT,
  DEFAULT_TEXT_WIDGET_DATA,
  DEFAULT_EFFECT,
  DEFAULT_LETTERSPACING,
  DEFAULT_FONT,
  DEFAULT_LINEHEIGHT,
};
